import { useState, useEffect, SyntheticEvent } from "react";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { Upload, Card, Image } from "antd";

import no_image_available from "../../../assets/pictures/no_image_available.jpg";
import useValue from "../../../hooks/useValue";
import Loading from "../Loading";

import type { UploadFile, UploadProps } from "antd";
import type FixMeLater from "../../../shared/types/fixMeLater.type";

const getBase64 = (file: FixMeLater): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const ImageUploader = (props: FixMeLater) => {
  const BASE_IMAGE_PATH = process.env.REACT_APP_BASE_IMAGE_PATH;

  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const { value: loading, handleDisableValue: handleDisableLoading, handleEnableValue: handleEnableLoading } = useValue(false);

  const handleChange: UploadProps["onChange"] = async ({ fileList: newFileList }) => {
    handleEnableLoading();
    props?.form.setFieldValue("logo_url", null);
    setFileList(newFileList);
    if (newFileList.length > 0) {
      props?.setImageFile(newFileList[0]?.originFileObj);
      const base64Image = await getBase64(newFileList[0].originFileObj as File);
      setPreviewImage(base64Image);
      props?.form?.setFieldValue("logo_url", newFileList[0]?.originFileObj);
    }
    handleDisableLoading();
  };

  const handleRemove = (file: UploadFile) => {
    const newFileList = fileList.filter((item) => item.uid !== file.uid);
    props?.form.setFieldValue("logo_url", null);
    setFileList(newFileList);
    setPreviewImage(null);
  };

  useEffect(() => {
    const fetchImage = async (image_url: string) => {
      setPreviewImage(`${BASE_IMAGE_PATH}/${image_url}`);
    };

    if (props?.imageUrl) {
      fetchImage(props?.imageUrl);
    }
  }, [props?.imageUrl]);

  const uploadButton = (
    <div
      style={{
        width: "250px",
        height: "110px",
        border: "1px dashed #D9D9D9",
        background: "#FAFAFA",
        borderRadius: "4px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        padding: "10px"
      }}
    >
      <PlusOutlined style={{ fontSize: "24px" }} />
      <div style={{ marginTop: 8, fontSize: "14px", color: "#545454" }}>Upload</div>
    </div>
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          {(!props?.imageUrl || !previewImage) && (
            <Upload disabled={props?.readEnabled ?? false} accept="image/*" fileList={fileList} onChange={handleChange} showUploadList={false}>
              {fileList.length >= 1 ? null : uploadButton}
            </Upload>
          )}

          {previewImage && (
            <Card
              hoverable
              style={{ padding: "0px", margin: "0px", width: "250px", height: "110px" }}
              bodyStyle={{ display: "none" }}
              cover={
                <Image
                  src={previewImage}
                  alt="Preview"
                  style={{ width: "250px", height: "100px", objectFit: "fill" }}
                  onError={(event: SyntheticEvent<HTMLImageElement>) => {
                    (event.target as HTMLImageElement).src = no_image_available;
                  }}
                />
              }
              actions={[!props?.themeValue?.logo_url ? <DeleteOutlined style={{ color: "red", fontSize: "18px" }} key="delete" onClick={() => handleRemove(fileList[0])} /> : null]}
            />
          )}
        </>
      )}
    </>
  );
};

export default ImageUploader;
